export default {
    local: 'http://localhost:49444',
    test: 'https://paragon-dash-api-test.azurewebsites.net',
    stage: 'https://paragon-dash-api-staging.azurewebsites.net',
    prod: 'https://paragon-dash-api.azurewebsites.net',
}



// WEBPACK FOOTER //
// ./src/Utils/DashApiServers.js


// WEBPACK FOOTER //
// webpack:///src/Utils/DashApiServers.js